<template>
  <span class="d-inline-block">
    <b-btn size="sm" @click.prevent="onClick" class="vgt-left-btn" :disabled="!subscribed">
      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
      </svg>
      Upload File
    </b-btn>
    <input type="file" ref="fileInput" @change="onFileChanged" class="d-none" accept=".csv, .xlsx">

    <b-modal class="product-modal" ref="modal" size="lg" lazy @hide-footer="true" title="Import Products">
      <div class="import--container">
        <div class="row">
          <div class="col-sm-12">
            <Alerts/>
            <LoadingSpinner v-if="isLoading"/>

            <div>
              <b-row>
                <b-col>
                  <table class="table mapping-table">
                    <thead>
                      <tr>
                        <th>GrandShipper Fields</th>
                        <th width="100"></th>
                        <th>Your File's Column Headers</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(col, i) in columns" :key="i">
                        <td class="text-right">{{ col }}</td>
                        <td></td>
                        <td>
                          <b-select
                            :options="field_options"
                            v-model="field_map[i]"
                            @change="onFieldSelect(i)"
                            size="sm"
                            :class="['d-block', 'w-100', {'is-invalid': isRequired(col) && !field_map[i]}]">
                          </b-select>
                            <!-- @change="onFieldSelect(i)" -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>

      <div slot="modal-footer">
        <b-button
          type="submit"
          variant="primary"
          :disabled="isMappingInvalid"
          @click="onSubmit">
        Import Products</b-button>
      </div>
    </b-modal>
  </span>
</template>
<style lang="scss" scoped>
.mapping-table {
  font-size: 18px;
}
</style>

<script>
import Papa from "papaparse";
import LoadingSpinner from "./LoadingSpinner";
import Alerts from "./Alerts";

export default {
  components: {
    LoadingSpinner,
    Alerts
  },
  props: {
    subscribed: Boolean,
    orderStatusId: Number
  },
  data() {
    return {
      invalidFile: false,
      isLoading: false,
      file: null,
      deselected: [],
      headers: [],
      rows: [],
      field_map: [],
      cols: {
        product_name: "Product",
        sku: "SKU",
        service_class: "Service Class",
        package_type: "Package Type",
        weight_lb: "Weight (lb)",
        weight_oz: "Weight (oz)",
        package_length: "Package Length",
        package_width: "Package Width",
        package_height: "Package Height",
        // packaging_weight: "Packaging Weight",
        declared_value: "Declared Value",
      }
    };
  },
  computed: {
    columns() {
      let headers = this.headers.length > 0 ? this.headers : [],
          field_map = [],
          valid = false;

      let options = _.map(this.cols, function(v) {
        if (headers.length > 0) {
          headers.forEach(f => {
            const vv = v.toLowerCase().trim();
            const ff = f.toLowerCase().trim();
            if(vv === "product" && (ff === "name" || ff == "product" || ff == "product name")) {
              field_map.push(f);
              valid = true;
            }else if(vv === "sku" && (ff === "sku" || ff === "product sku")) {
              field_map.push(f);
              valid = true;
            }else if(vv === "package type" && ff === "package") {
              field_map.push(f);
              valid = true;
            }else if(vv === "service class" && (ff === "service" || ff === "service class" || ff === "service type")) {
              field_map.push(f);
              valid = true;
            }else if(vv === "package length" && ff === "length") {
              field_map.push(f);
              valid = true;
            }else if(vv === "package width" && ff === "width") {
              field_map.push(f);
              valid = true;
            }else if(vv === "package height" && ff === "height") {
              field_map.push(f);
              valid = true;
            }else if(vv === "weight (lb)" && ff === "weight (lbs)") {
              field_map.push(f);
              valid = true;
            }else if (ff === vv){
              field_map.push(f);
              valid = true;
            }
          });
          if (!valid) field_map.push(null);
          valid = false;
        }
        return v;
      });
      this.field_map = field_map;
      return options
    },
    field_options() {
      if (this.headers.length > 0) {
        const options = this.headers
          .filter(f => f !== "")
          .map(f => {
            return { value: f, text: f }
          });

        return [ { value: null, text: "-- Ignore --" },...options ];
      }
      return [ { value: null, text: "-- Ignore --" } ];
    },
    mapped_fields() {
      let mapped = {};
      for (const [i, [k, v]] of Object.entries(Object.entries(this.cols))) {
        mapped[k] = this.field_map[i];
      }
      return mapped;
    },
    mapped_headers() {
      let headers = {};
      for (const [i, [k, v]] of Object.entries(Object.entries(this.cols))) {
        headers[v] = this.field_map[i];
      }
      return headers;
    },
    isMappingInvalid() {
      const req_fields = ["product_name", "service_class", "package_type"]
      const req_if = ["weight_lb", "weight_oz"]
      let isInvalid = false
      let cnt_1 = 0;
      req_if.forEach(f => {
        if (_.isEmpty(this.mapped_fields[f])) cnt_1++;
        isInvalid = cnt_1 >= req_if.length;
      })
      if (!isInvalid) {
        req_fields.forEach(f => {
          if (_.isEmpty(this.mapped_fields[f])) isInvalid = true
        })
      }
      return isInvalid
    }
  },
  mounted() {
    console.log("import");
    // this.field_map = Cookies.getJSON(`import-products-fieldmap`) || {};
  },
  methods: {
    onClick() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
      //this.show();
    },

    show() {
      this.$refs.modal.show();
    },

    hide() {
      this.$refs.modal.hide();
    },

    isRequired(col) {
      const req_fields = ["Product Name", "Service Class", "Package Type"]
      const req_if = ["Weight (lb)", "Weight (oz)"]
      let required = false;

      if (req_if.includes(col)){
        let counter = 0;
        req_if.forEach(f => {
          if (_.isEmpty(this.mapped_headers[f])) counter++;
        })
        if (counter >= req_if.length) required = true;
      }
      if (req_fields.includes(col)) required = true;
      return required;
    },

    onFieldSelect(i){
      return function(val){
        this.field_map = _.map(this.field_map, (field, index) => {
          if(field === val && index != i) {
            field = null;
          }
          return field;
        })
      };
    },

    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsBinaryString(file);
      });
    },

    isCSV() {
      if (this.file) return /\.csv$/i.test(this.file.name);
      return false;
    },

    async onFileChanged(e) {
      this.isLoading = true;
      this.rows = [];
      this.$emit("alert_close");

      this.file = e.target.files[0];

      let content = null;

      if (!this.isCSV()) {
        await this.uploadError("Invalid format. Please provide a CSV file.")
        return;
      }

      try {
        content = await this.readFileAsync(this.file);
      } catch (e) {
        await this.uploadError("Failed to read file.")
        return;
      }

      let result = Papa.parse(content, {header: true,});

      if (!result.data.length) {
        await this.uploadError("Invalid file: no rows present.")
        return;
      }

      if (result.data.length > 2501) {
        await this.uploadError("Unable to proceed, you've exceeded the maximum records allowed per upload.")
        return;
      }

      this.rows = result.data[0];
      this.headers = Object.keys(result.data[0], k => k !== "")

      this.show();
      this.isLoading = false;
    },

    async uploadError(msg) {
      this.$parent.$emit("alert", {
        message: msg,
        type: "danger"
      });
      this.restart();
    },

    async onSubmit(e) {
      e.preventDefault();
      this.isLoading = true;
      try{
        let formData = new FormData();
        formData.append('file', this.file);
        formData.append('field_map', JSON.stringify(this.mapped_fields));

        await axios.post('/products/import', formData)
      }catch(e){
        console.log('error', e);
        // alert("Sorry, there's a problem uploading file. If this keeps happening please contact us.");
      }finally{
        this.restart();
        this.$emit('imported')
        this.hide();
      }
    },

    restart() {
      this.isLoading = false;

      this.invalidFile = false;
      this.file = null;
      this.rows = [];
    },
  },
  watch: {
    deselected: function(newVal, oldVal) {
      this.rows = this.rows.map((row, key) => {
        row._rowVariant = newVal.includes(key) ? "danger" : "";
        return row;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ImportProductsButton.vue